/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicExternalTagReferenceDto } from './PublicExternalTagReferenceDto';
import type { PublicFilterDomainConditionDto } from './PublicFilterDomainConditionDto';

export type PublicTagFilterDomainConditionDto = (PublicFilterDomainConditionDto & {
    /**
     * Operator of the condition
     */
    operator?: PublicTagFilterDomainConditionDto.operator;
    /**
     * List of the tags references in the condition
     */
    tags?: Array<PublicExternalTagReferenceDto>;
} & {
    /**
     * Operator of the condition
     */
    operator: PublicTagFilterDomainConditionDto.operator;
    /**
     * List of the tags references in the condition
     */
    tags: Array<PublicExternalTagReferenceDto>;
});

export namespace PublicTagFilterDomainConditionDto {

    /**
     * Operator of the condition
     */
    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
